import { ListContainer } from 'components';
import InviteUser from 'containers/servicer-users/InviteUser';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { texts } from 'utils/languages/fr';
import DistributorUsersTable from './DistributorUsersTable';

const DistributorUsers = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/invite`}
                    render={() => <InviteUser title={texts.CREATE_USER} type="cif" />}
                />
                <Route path={path} component={DistributorUsersTable} />
            </Switch>
        </ListContainer>
    );
};

export default DistributorUsers;
